import React, { useState, useRef, useEffect } from 'react';

// Dropdown chọn nhiều ngày kèm ô tìm kiếm — dùng khi danh sách ngày dài dần theo thời gian,
// thay cho dãy pill (không co giãn tốt khi có nhiều ngày).
export default function DateMultiSelect({ options, selected, onChange, placeholder = 'Chọn ngày…' }) {
  const [isOpen, setIsOpen] = useState(false);
  const [search, setSearch] = useState('');
  const wrapperRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const filteredOptions = options.filter((d) => d.toLowerCase().includes(search.toLowerCase()));

  const toggleOption = (date) => {
    onChange(selected.includes(date) ? selected.filter((d) => d !== date) : [...selected, date]);
  };

  const label = selected.length === 0
    ? placeholder
    : selected.length === 1
      ? selected[0]
      : `${selected.length} ngày đã chọn`;

  return (
    <div ref={wrapperRef} style={{ position: 'relative', display: 'inline-block', minWidth: '220px' }}>
      <button
        type="button"
        onClick={() => setIsOpen((v) => !v)}
        style={{
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: '8px',
          padding: '6px 10px',
          borderRadius: '6px',
          border: '1px solid var(--border-subtle)',
          background: 'var(--bg-card)',
          color: selected.length ? '#38bdf8' : 'var(--text-muted)',
          fontSize: '12px',
          fontWeight: '600',
          cursor: 'pointer'
        }}
      >
        <span><i className="fa-solid fa-calendar-days" style={{ marginRight: '6px' }}></i>{label}</span>
        <i className={`fa-solid fa-chevron-${isOpen ? 'up' : 'down'}`} style={{ fontSize: '10px' }}></i>
      </button>

      {isOpen && (
        <div
          style={{
            position: 'absolute',
            top: 'calc(100% + 4px)',
            left: 0,
            zIndex: 50,
            width: '260px',
            maxHeight: '320px',
            display: 'flex',
            flexDirection: 'column',
            background: 'var(--bg-card, #191f2c)',
            border: '1px solid var(--border-subtle)',
            borderRadius: '8px',
            boxShadow: '0 10px 30px rgba(0,0,0,0.5)',
            overflow: 'hidden'
          }}
        >
          <div style={{ padding: '8px', borderBottom: '1px solid var(--border-subtle)' }}>
            <input
              type="text"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              placeholder="Tìm ngày (vd 2026-09-15)…"
              autoFocus
              style={{
                width: '100%',
                padding: '6px 8px',
                borderRadius: '5px',
                border: '1px solid var(--border-subtle)',
                background: 'rgba(255,255,255,0.04)',
                color: 'white',
                fontSize: '12px',
                outline: 'none'
              }}
            />
          </div>

          <div style={{ display: 'flex', justifyContent: 'space-between', padding: '6px 8px', borderBottom: '1px solid var(--border-subtle)' }}>
            <button type="button" onClick={() => onChange(options)} style={{ background: 'none', border: 'none', color: '#38bdf8', fontSize: '11px', cursor: 'pointer', padding: 0 }}>Chọn tất cả</button>
            <button type="button" onClick={() => onChange([])} style={{ background: 'none', border: 'none', color: 'var(--text-muted)', fontSize: '11px', cursor: 'pointer', padding: 0 }}>Bỏ chọn</button>
          </div>

          <div style={{ overflowY: 'auto', padding: '4px 0' }}>
            {filteredOptions.length === 0 && (
              <div style={{ padding: '10px', fontSize: '12px', color: 'var(--text-muted)' }}>Không tìm thấy ngày phù hợp.</div>
            )}
            {filteredOptions.map((date) => (
              <label
                key={date}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  padding: '6px 10px',
                  fontSize: '12px',
                  color: 'white',
                  cursor: 'pointer'
                }}
              >
                <input type="checkbox" checked={selected.includes(date)} onChange={() => toggleOption(date)} />
                {date}
              </label>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
